import React from 'react';
import { CopyOutlined, DeleteOutlined, ClearOutlined } from '@ant-design/icons';
import { C } from '../../constants/design-tokens';
import { useResponsiveSizes } from '../../../../hooks/use-responsive-sizes';
import { useEditorContext } from '../../context/editor-context';

const ActionButton: React.FC<{
  icon: React.ReactNode;
  label: string;
  color?: string;
  hoverColor?: string;
  onClick: () => void;
}> = ({ icon, label, color = C.textSecondary, hoverColor, onClick }) => {
  const { spacing, fontSize } = useResponsiveSizes();
  const [hovered, setHovered] = React.useState(false);

  return (
    <div
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: spacing.xs,
        padding: `${spacing.xs}px ${spacing.sm}px`,
        borderRadius: 8,
        cursor: 'pointer',
        fontSize: fontSize.md,
        fontWeight: 500,
        color: hovered ? hoverColor || C.textPrimary : color,
        background: hovered ? C.surface : 'transparent',
        transition: 'all 0.15s ease',
        userSelect: 'none'
      }}
    >
      {icon}
      {label && <span>{label}</span>}
    </div>
  );
};

export const SceneHeader: React.FC = () => {
  const { activeIndex, totalScenes, onDuplicate, onRemove, onReset } = useEditorContext();
  const { spacing, fontSize, iconSize } = useResponsiveSizes();

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: spacing.md
      }}
    >
      {/* Left: badge + label */}
      <div style={{ display: 'flex', alignItems: 'center', gap: spacing.sm }}>
        <span
          style={{
            background: C.accent,
            color: '#fff',
            fontSize: fontSize.sm,
            fontWeight: 500,
            padding: `${spacing.xs}px ${spacing.sm}px`,
            borderRadius: 6,
            letterSpacing: 0.4,
            textTransform: 'uppercase'
          }}
        >
          Escena {String(activeIndex + 1).padStart(2, '0')}
        </span>
      </div>

      {/* Right: actions */}
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <ActionButton icon={<CopyOutlined style={{ fontSize: iconSize.sm }} />} label='' onClick={onDuplicate} />
        <ActionButton icon={<ClearOutlined style={{ fontSize: iconSize.sm }} />} label='' onClick={onReset} />
        {totalScenes > 1 && (
          <ActionButton
            icon={<DeleteOutlined style={{ fontSize: iconSize.sm }} />}
            label=''
            color={C.danger}
            hoverColor={C.danger}
            onClick={onRemove}
          />
        )}
      </div>
    </div>
  );
};
